import { OrderFulfilmentType } from 'store/models/sellModels'
import DeliveryDiningRoundedIcon from '@mui/icons-material/DeliveryDiningRounded'
import RestaurantRoundedIcon from '@mui/icons-material/RestaurantRounded'
import LocalMallRoundedIcon from '@mui/icons-material/LocalMallRounded'
import StorefrontIcon from '@mui/icons-material/Storefront'
import { SvgIconProps } from '@mui/material'
interface IFulfillmentType {
    label: string
    id: number
    icon: any
    type: OrderFulfilmentType
}
interface IFulfillmentTypeMap {
    label: string
    icon: any
    type: OrderFulfilmentType
}
interface IFulfillmentTypeIconProps extends SvgIconProps {
    fulfillmentType: OrderFulfilmentType
}
export function FulfillmentTypeIcon(props: IFulfillmentTypeIconProps) {
    const { fulfillmentType: type, ...iconProps } = props
    switch (type) {
        case OrderFulfilmentType.DINE_IN:
            return <RestaurantRoundedIcon {...iconProps} />
        case OrderFulfilmentType.TAKEAWAY:
            return <LocalMallRoundedIcon {...iconProps} />
        case OrderFulfilmentType.PICKUP:
            return <StorefrontIcon {...iconProps} />
        case OrderFulfilmentType.DELIVERY:
            return <DeliveryDiningRoundedIcon {...iconProps} />
        default:
            return <></>
    }
}

export function getOrderFulfillmentTypeMap(
    scale: number = 1,
    color:
        | 'action'
        | 'inherit'
        | 'primary'
        | 'secondary'
        | 'error'
        | 'info'
        | 'success'
        | 'warning' = 'primary',
): Record<OrderFulfilmentType, IFulfillmentTypeMap> {
    return {
        [OrderFulfilmentType.DELIVERY]: {
            label: 'Delivery',
            type: OrderFulfilmentType.DELIVERY,
            icon: (
                <FulfillmentTypeIcon
                    fulfillmentType={OrderFulfilmentType.DELIVERY}
                    color={color}
                    style={{ transform: `scale(${scale})` }}
                />
            ),
        },
        [OrderFulfilmentType.DINE_IN]: {
            label: 'Dine In',
            type: OrderFulfilmentType.DINE_IN,
            icon: (
                <FulfillmentTypeIcon
                    fulfillmentType={OrderFulfilmentType.DINE_IN}
                    color={color}
                    style={{ transform: `scale(${scale})` }}
                />
            ),
        },
        [OrderFulfilmentType.PICKUP]: {
            label: 'Pickup',
            type: OrderFulfilmentType.PICKUP,
            icon: (
                <FulfillmentTypeIcon
                    fulfillmentType={OrderFulfilmentType.PICKUP}
                    color={color}
                    style={{ transform: `scale(${scale})` }}
                />
            ),
        },
        [OrderFulfilmentType.TAKEAWAY]: {
            label: 'Takeaway',
            type: OrderFulfilmentType.TAKEAWAY,
            icon: (
                <FulfillmentTypeIcon
                    fulfillmentType={OrderFulfilmentType.TAKEAWAY}
                    color={color}
                    style={{ transform: `scale(${scale})` }}
                />
            ),
        },
    }
}

export function getOrderFulfillmentType(
    scale: number = 1,
    color: string = '#fff',
): IFulfillmentType[] {
    return [
        {
            id: 1,
            label: 'Dine In',
            type: OrderFulfilmentType.DINE_IN,
            icon: (
                <FulfillmentTypeIcon
                    fulfillmentType={OrderFulfilmentType.DINE_IN}
                    style={{ fill: color, transform: `scale(${scale})` }}
                />
            ),
        },
        {
            id: 2,
            label: 'Takeaway',
            type: OrderFulfilmentType.TAKEAWAY,
            icon: (
                <FulfillmentTypeIcon
                    fulfillmentType={OrderFulfilmentType.TAKEAWAY}
                    style={{ fill: color, transform: `scale(${scale})` }}
                />
            ),
        },
        {
            id: 3,
            label: 'Pickup',
            type: OrderFulfilmentType.PICKUP,
            icon: (
                <FulfillmentTypeIcon
                    fulfillmentType={OrderFulfilmentType.PICKUP}
                    style={{ fill: color, transform: `scale(${scale})` }}
                />
            ),
        },
        {
            id: 4,
            label: 'Delivery',
            type: OrderFulfilmentType.DELIVERY,
            icon: (
                <FulfillmentTypeIcon
                    fulfillmentType={OrderFulfilmentType.DELIVERY}
                    style={{ fill: color, transform: `scale(${scale})` }}
                />
            ),
        },
    ]
}
